import {
  AdministrationActiveCertificateDetailsInterface,
  AdministrationCertificateListItemInterface,
  AdministrationCoursesListInterface,
  AdministrationCyclicalLessonsListInterface,
  AdministrationDashboardStatisticsInterface,
  AdministrationUserCertificatesQueryInterface,
  AdministrationUserDetailsInterface,
  AdministrationUserListInterface,
  AdministrationUserListItemInterface,
  AdministrationUserPathRequestDetailsInterface,
  AdministrationUserPathRequestsListInterface,
  AdministrationUserPathRequestsQueryInterface,
  AdministrationUsersListQueryInterface,
  CompanyListItemInterface,
  IPaginatorData,
} from '@elearning-platform/api-types/interfaces';
import { stringify } from 'query-string';

import { AdministrationCompanyListParams } from '../../interfaces/api';
import { api } from '../api';

export const getAdministrationUserDetails: (id: number) => Promise<AdministrationUserDetailsInterface>
  = (id: number): Promise<AdministrationUserDetailsInterface> => api.get(
    `users-administration/${id}`
  );

export const getAdministrationCompanyList: (
  params?: AdministrationCompanyListParams
) => Promise<IPaginatorData<CompanyListItemInterface>> = (
  params: AdministrationCompanyListParams = {}
): Promise<IPaginatorData<CompanyListItemInterface>> => api.get(
  `users-administration/companies-list?${stringify(params, { skipEmptyString: true })}`
);

export const getAdministrationUsersList: (
  companyId: number, params?: AdministrationUsersListQueryInterface
) => Promise<AdministrationUserListInterface> = (
  companyId: number, params: AdministrationUsersListQueryInterface = {}
): Promise<AdministrationUserListInterface> => api.get(
  `users-administration/employees-list/${companyId}?${stringify(params, { skipEmptyString: true, arrayFormat: 'bracket' })}`
);

export const getAdministrationStatistics: (
  companyId: number,
) => Promise<AdministrationDashboardStatisticsInterface> = (
  companyId: number,
): Promise<AdministrationDashboardStatisticsInterface> => api.get(
  `users-administration/${companyId}/dashboard/statistics`
);

export const getAdministrationCourses: (
  companyId: number,
) => Promise<AdministrationCoursesListInterface[]> = (
  companyId: number,
): Promise<AdministrationCoursesListInterface[]> => api.get(
  `users-administration/${companyId}/courses`
);

export const getAdministrationActiveCertificates: (
  companyId: number,
) => Promise<AdministrationActiveCertificateDetailsInterface[]> = (
  companyId: number,
): Promise<AdministrationActiveCertificateDetailsInterface[]> => api.get(
  `users-administration/active-certificates/${companyId}`
);

export const getAdministrationCyclicalLessons: (
  companyId: number,
) => Promise<AdministrationCyclicalLessonsListInterface[]> = (
  companyId: number,
): Promise<AdministrationCyclicalLessonsListInterface[]> => api.get(
  `users-administration/${companyId}/cyclical-lessons`
);

export const getAdministrationUsersPendingOffboardingList: (
  params?: AdministrationUsersListQueryInterface
) => Promise<IPaginatorData<AdministrationUserListItemInterface>> = (
  params: AdministrationUsersListQueryInterface = {}
): Promise<IPaginatorData<AdministrationUserListItemInterface>> => api.get(
  `users-administration/deactivation-list?${stringify(params, { skipEmptyString: true, arrayFormat: 'bracket' })}`
);

export const getUserCertificatesList: (
  id: number, params: AdministrationUserCertificatesQueryInterface
) => Promise<AdministrationCertificateListItemInterface[]> = (
  id: number, params: AdministrationUserCertificatesQueryInterface,
): Promise<AdministrationCertificateListItemInterface[]> => api.get(
  `users-administration/${id}/certificates?${stringify(params, { skipEmptyString: true, arrayFormat: 'bracket' })}`
);

export const getUserCertificate: (certificateId: number) => Promise<void> = (certificateId: number): Promise<void> => api.get(
  `users-administration/certificates/download/${certificateId}`, { responseType: 'blob' }
);

export const getEmployeePathRequestDetails: (id: number) => Promise<AdministrationUserPathRequestDetailsInterface> = (
  id: number
): Promise<AdministrationUserPathRequestDetailsInterface> => api.get(
  `users-administration/path-requests/${id}`
);

export const getUsersWithOfwcaPath: (
  companyId: number, params: AdministrationUserPathRequestsQueryInterface
) => Promise<AdministrationUserPathRequestsListInterface> = (
  companyId: number, params: AdministrationUserPathRequestsQueryInterface
): Promise<AdministrationUserPathRequestsListInterface> => api.get(
  `users-administration/${companyId}/path-requests?${stringify(params, { skipEmptyString: true })}`
);
